export enum SystemServiceErrorEnum {
  brokerServiceAccountList = 1001,
  connectedAs = 1002,
  info = 1003,
  token = 1004,
  refresh_token = 1005,
  loadPredefinedWorkspaces = 1006,
  addWks = 1007,
  afcSearchQuestions = 1008,
  tokenOrSessionStorage = 1009,
  terms_use_invalid_token = 1010,
  terms_use_Sign = 1011,
  config_whitelabel = 1012,
  loginDuplicated = 1013,
  valideToken = 1014,
  statusWebSocket = 1015,
  onReconnectSocket = 1016,
  validate_token = 1017
}

export enum SystemServiceErrorCodKeyEnum {
  empty = 1,
  error = 1,
  unautorized = 2,
  internoLogin = 3,
  invalid = 4
}
